import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import { selectLocaleDict } from 'features/locale/selectors'

import { Button } from 'components/UIKit/Button/Button'

import './FreeSpinModal.scss'

const b = block('free-spin-modal')

export const FreeSpinModal: React.FC = () => {
  const history = useHistory()
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const handleClickButton = useCallback(() => {
    history.push(ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.completed))
  }, [history])

  return (
    <div className={b()}>
      <div className={b('wrapper')}>
        <p className={b('header')}>{locale.freeSpinEnd}</p>
        <div className={b('content')}>
          <p className={b('text')}>{locale.freeSpinEndText}</p>
          <div className={b('button')}>
            <Button text={locale.promotions} onClick={handleClickButton} />
          </div>
        </div>
      </div>
    </div>
  )
}
